import { render } from "./KeywordHelper.vue?vue&type=template&id=1535c702&ts=true"
import script from "./KeywordHelper.ts?vue&type=script&lang=ts&external"
export * from "./KeywordHelper.ts?vue&type=script&lang=ts&external"

import "./KeywordHelper.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__